var messages = {
  currentDate: 'Current date'
};
export default messages;